module.exports = {
    KNOWN_ERROR_CODE: 'KNOWN_ERROR_CODE',
    PENDING: 'PENDING',
    REJECTED: 'REJECTED',
    LOW_CREDIT_SCORE: 'LOW_CREDIT_SCORE',
    HIRE_BLOCKED: 'HIRE_BLOCKED',
};
